import { Router } from '@angular/router';
import { Component, OnInit, Output, EventEmitter, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { LoginService } from 'src/app/_services/login.service';
import { CustomValidator } from 'src/app/_services/customValidator';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  ProfileDetails: any;
  changepassword_form: FormGroup;
  show1:boolean = false;
  show:boolean = false;
  show2:boolean = false;

  incorrectoldpw: boolean = false;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @ViewChild('successModal') successModal: TemplateRef<any>;

  constructor(public modalService: NgbModal, private fb: FormBuilder,
    private _localstorageservice: LocalStorageService, private _loginservice: LoginService , private router : Router) { }

  ngOnInit() {

    this.changepassword_form = this.fb.group({
      old_pwd: ['', Validators.required],
      new_pwd: ['', Validators.required],
      confirm_pwd: ['', Validators.required],
    })
  }


  reconfirmpwd() {
    if (this.changepassword_form.value.new_pwd == this.changepassword_form.value.confirm_pwd) {
      return this.changepassword_form['controls'].confirm_pwd.setErrors(null)
    } else {
      return this.changepassword_form['controls'].confirm_pwd.setErrors({ 'invalidpwd': true })
    }
  }

  checkpassword(){
    if (this.changepassword_form.value.old_pwd == this.changepassword_form.value.new_pwd) {
      return this.changepassword_form['controls'].new_pwd.setErrors({ 'pwdmatch': true })
    } else {
      return this.changepassword_form['controls'].new_pwd.setErrors(null)
    }
  }

  changePassword() {
    if (this.changepassword_form.valid) {

      let data =
      {
        "loginemail": this.ProfileDetails.loginemail,
        "oldpassword": this.changepassword_form.value.old_pwd,
        "newpassword": this.changepassword_form.value.new_pwd
      }
      this._loginservice.changeuserPassword(data).subscribe((res: any) => {
        if (res.status == "success") {
          this.modalService.dismissAll();
          // this.passEntry.emit('success')
          const modalRef = this.modalService.open(this.successModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
        }
        else if (res.status == 'failure' && res.message == 'Incorrect old password') {
          this.incorrectoldpw = true
        }
        else {
          this.modalService.dismissAll();
          this.passEntry.emit('error')

        }
      })
    }
    else {
      this.validateAllFormFields(this.changepassword_form);
    }



  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });

  }
  modaldismiss(){
    this.modalService.dismissAll()
    let chromeid = localStorage.getItem('extensionID');
    localStorage.clear()
    localStorage.setItem('extensionID', chromeid)
    this.router.navigateByUrl('/login')
  }
}
